import React, { useContext } from "react";
import { Row, Col } from "reactstrap";
import { AnswerContext } from "../Module/AnswerContext";
import QuetionStep from "./Steps/QuetionStep";

const QuetionForm: React.FC<number> = ({ page_num }: any) => {
  const { orgs } = useContext(AnswerContext);

  const quetion = orgs.map((obj: any, index: number) =>
    index == page_num ? (
      <>
        <div className="org_subtitle_sec">
          <h4 className="org_subtitle">{obj.node.name}</h4>
        </div>
        <div className="org_item comparion_item">
          {obj.node.quetion.edges.map((q: any, i: number) => (
            <Row key={i}>
              <Col>
                <QuetionStep quetion={q} />
              </Col>
            </Row>
          ))}
        </div>
      </>
    ) : (
      <></>
    )
  );
  return <>{quetion}</>;
};

export default QuetionForm;
